import React from "react";

import "./SocialSecurityNumber.css";

export const SocialSecurityNumber: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="social-security-number">{children}</div>;
